var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wallet-main"},[_c('the-wallet-side-menu'),_c('v-main',[_c('v-container',{staticClass:"pa-2 pa-md-3 mb-14",attrs:{"fluid":""}},[_c('module-confirmation'),_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }